<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="services"
      :items="services"
      :fields="servicesFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>

    <b-modal hide-footer :title="$t('Select type service')" ref="modalTypeServices" id="modalTypeServices">

      <basic-table
        :items="servicesTypeList"
        :fields="servicesTypeFields"
        @RowSelected="selectServices"
        @ClickOnEditButton="showSelectService"/>

      <modal-ok-cancel @save="showSelectService" @cancel="$bvModal.hide('modalTypeServices')" saveButtonLabel="Ok"/>
    </b-modal>

    <FormOnceServices
      :serviceType="serviceType"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :groupList="groupList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormPeriodicServices
      :serviceType="serviceType"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormIPtrafficService
      :serviceType="serviceType"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormHotspotServices
      :serviceType="serviceType"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :timeRangeList="timeRangeList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormDialupServices
      :serviceType="serviceType"
      :policyList="policyList"
      :schemeList="schemeList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :ipPoolsList="ipPoolsList"
      :timeRangeList="timeRangeList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormTelephoneService
      :serviceType="serviceType"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormIPTVService
      :serviceType="serviceType"
      :policyList="policyList"
      :schemeList="schemeList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormVodService
      :serviceType="serviceType"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

    <FormFreezedService
      :serviceType="serviceType"
      :isEdit="isEdit"
      :editItem="selectedServices"/>

  </div>
</template>

<script>
import FormOnceServices from '../formOnceService'
import FormPeriodicServices from '../formPeriodicService'
import FormIPtrafficService from '../formIPtrafficService'
import FormHotspotServices from '../formHotspotService'
import FormDialupServices from '../formDialupService'
import FormTelephoneService from '../formTelephonyService'
import FormIPTVService from '../formIPTVService'
import FormVodService from '../formVodService'
import FormFreezedService from '../formFreezedService'

export default {
  components: {
    FormOnceServices,
    FormPeriodicServices,
    FormIPtrafficService,
    FormHotspotServices,
    FormDialupServices,
    FormTelephoneService,
    FormIPTVService,
    FormVodService,
    FormFreezedService
  },
  data () {
    return {
      servicesFields: [
        {key: 'service_id', label: 'ID', sortable: true},
        {key: 'service_name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'nameServicesType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      servicesTypeList: [
        {typeName: this.$i18n.t('One-time service'), int: 1},
        {typeName: this.$i18n.t('Periodic service'), int: 2},
        {typeName: this.$i18n.t('IP traffic service'), int: 3},
        {typeName: this.$i18n.t('Hotspot service'), int: 4},
        {typeName: this.$i18n.t('Dial-up service'), int: 5},
        {typeName: this.$i18n.t('Telephony service'), int: 6},
        {typeName: this.$i18n.t('IPTV service'), int: 8},
        {typeName: this.$i18n.t('Video on demand'), int: 9},
        {typeName: this.$i18n.t('Freezed service'), int: 10}
      ],
      servicesTypeFields: [
        {key: 'typeName', label: ''}
      ],
      isEdit: false,
      serviceType: 0,
      selectedTypeService: null,
      selectedServices: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.isEdit = false
      this.selectedTypeService = null
      this.$refs.modalTypeServices.show()
    },
    selectServices (item) {
      this.selectedTypeService = item
    },
    showSelectService (item) {
      if (item) {
        this.selectedTypeService = item
      }
      if (!this.selectedTypeService) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select service'), 'Error')
        return
      }
      this.serviceType = this.selectedTypeService.int
      switch (this.selectedTypeService.int) {
        case 1:
          this.selectedServices = {
            parent_id: 0,
            tariff_id: 0,
            service_name: '',
            contract_type: 0,
            comment: '',
            cost: 0,
            drop_from_group: 0,
            invoice_sup_id: 0,
            link_by_default: 1,
            multiple_linking: 0
          }
          this.$root.$emit('bv::show::modal', 'modalOnceService', '#btnShow')
          break
        case 2:
          this.selectedServices = {
            parent_id: 0,
            tariff_id: 0,
            service_name: '',
            contract_type: 0,
            comment: '',
            cost: 0,
            invoice_sup_id: 0,
            charge_method: 1,
            scheme_id: 0,
            policy_id: 1,
            link_by_default: 1,
            multiple_linking: 0,
            links_count: 0
          }
          this.$root.$emit('bv::show::modal', 'modalPeriodicService', '#btnShow')
          break
        case 3:
          this.selectedServices = {
            iptraffic_service_data: {
              aggregation_interval: 0,
              borders: [],
              null_service_prepaid: false,
              prepaid: [],
              service_id: 0,
              tclass_id2group: []
            },
            periodic_service_data: {
              policy_id: 1,
              charge_method: 1,
              cost: 0,
              expire_date: 0,
              have_tried_to_del: 0,
              radius_sessions_limit: 0,
              scheme_id: 0,
              service_id: 0,
              links_count: 0
            },
            service_data: {
              comment: '',
              contract_type: 0,
              invoice_sup_id: 0,
              is_dynamic: 0,
              link_by_default: 1,
              links_count: 0,
              multiple_linking: 0,
              parent_id: 0,
              service_name: '',
              tariff_id: 0
            }
          }
          this.$root.$emit('bv::show::modal', 'modalIPtrafficService', '#btnShow')
          break
        case 4:
          this.selectedServices = {
            hotspot_service_data: {
              recv_cost: 0,
              rate_limit: '',
              costs: [],
              allowed_net: []
            },
            periodic_service_data: {
              charge_method: 1,
              scheme_id: 0,
              radius_sessions_limit: 0,
              cost: 0,
              policy_id: 1,
              links_count: 0
            },
            service_data: {
              comment: '',
              contract_type: 0,
              invoice_sup_id: 0,
              links_count: 0,
              is_dynamic: 0,
              link_by_default: 1,
              parent_id: 0,
              service_name: '',
              tariff_id: 0
            }
          }
          this.$root.$emit('bv::show::modal', 'modalHotspotService', '#btnShow')
          break
        case 5:
          this.selectedServices = {
            periodic_service_data: {
              charge_method: 1,
              cost: 0,
              radius_sessions_limit: '',
              policy_id: 1,
              links_count: 0
            },
            service_data: {
              service_id: 0,
              comment: '',
              parent_id: 0,
              links_count: 0,
              is_dynamic: 0,
              link_by_default: 1,
              service_name: '',
              tariff_id: 0,
              contract_type: 0
            },
            dialup_service_data: {
              pool_name: '',
              max_timeout: 86400,
              login_prefix: '',
              costs: [],
              pool_id: 0
            }
          }
          this.$root.$emit('bv::show::modal', 'modalDialupService', '#btnShow')
          break
        case 6:
          this.selectedServices = {
            periodic_service_data: {
              policy_id: 1,
              charge_method: 1,
              cost: 0,
              radius_sessions_limit: '',
              scheme_id: 0,
              links_count: 0
            },
            service_data: {
              comment: '',
              parent_id: 0,
              is_dynamic: 0,
              links_count: 0,
              link_by_default: 1,
              service_name: '',
              tariff_id: 0,
              contract_type: 0
            },
            telephony_service_data: {
              cost_info: {
                cost_table: [],
                discount_free_time: true,
                first_period_length: '',
                first_period_step: '',
                free_time: '',
                min_charge: '',
                second_period_step: 1,
                supplier_id: 0,
                time_unit_size: 60
              }
            }
          }
          this.$root.$emit('bv::show::modal', 'modalTelephoneService', '#btnShow')
          break
        case 8:
          this.selectedServices = {
            iptv_service_data: {
              media_content: 0,
              media_group: 0,
              custom_data: '',
              iptv_type: 0
            },
            periodic_service_data: {
              charge_method: 1,
              cost: 0,
              policy_id: 1,
              links_count: 0
            },
            service_data: {
              comment: '',
              contract_type: 0,
              invoice_sup_id: 0,
              is_dynamic: 0,
              parent_id: 0,
              links_count: 0,
              service_name: '',
              tariff_id: 0,
              link_by_default: 1,
              multiple_linking: 0
            }
          }
          this.$root.$emit('bv::show::modal', 'modalIPTVService', '#btnShow')
          break
        case 9:
          this.selectedServices = {
            vod_service_data: {
              media_content: 0,
              media_group: 0,
              custom_data: '',
              duration: 86400,
              type: 0
            },
            periodic_service_data: {
              charge_method: 0,
              cost: 0,
              links_count: 0
            },
            service_data: {
              comment: '',
              contract_type: 0,
              invoice_sup_id: 0,
              is_dynamic: 0,
              links_count: 0,
              link_by_default: 1,
              multiple_linking: 0,
              parent_id: 0,
              service_name: '',
              tariff_id: 0
            }
          }
          this.$root.$emit('bv::show::modal', 'modalVodService', '#btnShow')
          break
        case 10:
          this.selectedServices = {
            freezed_service_data: {
              charge_type_action: 0,
              cost: 0
            },
            service_data: {
              comment: '',
              contract_type: 0,
              invoice_sup_id: 0,
              is_dynamic: 0,
              links_count: 0,
              link_by_default: 1,
              multiple_linking: 0,
              service_name: '',
              tariff_id: 0,
              service_id: 0
            }
          }
          this.$root.$emit('bv::show::modal', 'modalFreezedService', '#btnShow')
          break
      }
      this.$refs.modalTypeServices.hide()
    },
    editItem (item) {
      this.selectedServices = null
      this.isEdit = true
      this.serviceType = item.service_type
      switch (item.service_type) {
        case 1:
          this.selectedServices = JSON.parse(JSON.stringify(item))
          this.$store.dispatch('Tariffing/GET_ONE_TIME_SERVICE', item.service_id).then(response => {
            this.$set(this.selectedServices, 'cost', 0)
            this.selectedServices.cost = this.$store.getters['Tariffing/ONE_TIME_SERVICE'].once_service_data.cost
            this.selectedServices.invoice_sup_id = this.$store.getters['Tariffing/ONE_TIME_SERVICE'].service_data.invoice_sup_id
            this.selectedServices.drop_from_group = this.$store.getters['Tariffing/ONE_TIME_SERVICE'].once_service_data.drop_from_group
            this.$root.$emit('bv::show::modal', 'modalOnceService', '#btnShow')
          })
          break
        case 2:
          this.selectedServices = JSON.parse(JSON.stringify(item))
          this.$store.dispatch('Tariffing/GET_PERIODIC_SERVICE', item.service_id).then(response => {
            this.$set(this.selectedServices, 'cost', 0)
            this.selectedServices.cost = this.$store.getters['Tariffing/PERIODIC_SERVICE'].periodic_service_data.cost
            this.selectedServices.invoice_sup_id = this.$store.getters['Tariffing/PERIODIC_SERVICE'].service_data.invoice_sup_id
            this.selectedServices.charge_method = this.$store.getters['Tariffing/PERIODIC_SERVICE'].periodic_service_data.charge_method
            this.selectedServices.policy_id = this.$store.getters['Tariffing/PERIODIC_SERVICE'].periodic_service_data.policy_id
            this.selectedServices.scheme_id = this.$store.getters['Tariffing/PERIODIC_SERVICE'].periodic_service_data.scheme_id
            this.$root.$emit('bv::show::modal', 'modalPeriodicService', '#btnShow')
          })
          break
        case 3:
          this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SERVICES', item)
          this.$store.dispatch('Tariffing/GET_IP_TRAFFIC_SERVICE', item.service_id).then(response => {
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/IP_TRAFFIC_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalIPtrafficService', '#btnShow')
          })
          break
        case 4:
          this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SERVICES', item)
          this.$store.dispatch('Tariffing/GET_HOTSPOT_SERVICE', item.service_id).then(response => {
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/HOTSPOT_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalHotspotService', '#btnShow')
          })
          break
        case 5:
          this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SERVICES', item)
          this.$store.dispatch('Tariffing/GET_DIALUP_SERVICE', item.service_id).then(response => {
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/DIALUP_SERVICE']))
            this.$set(this.selectedServices.dialup_service_data, 'pool_id', 0)
            this.$root.$emit('bv::show::modal', 'modalDialupService', '#btnShow')
          })
          break
        case 6:
          this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SERVICES', item)
          this.$store.dispatch('Tariffing/GET_TELEPHONY_SERVICE', item.service_id).then(response => {
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TELEPHONY_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalTelephoneService', '#btnShow')
          })
          break
        case 8:
          this.$store.dispatch('Tariffing/GET_IPTV_SERVICE', item.service_id).then(response => {
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/IPTV_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalIPTVService', '#btnShow')
          })
          break
        case 9:
          this.$store.dispatch('Tariffing/GET_VOD_SERVICE', item.service_id).then(response => {
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/VOD_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalVodService', '#btnShow')
          })
          break
        case 10:
          this.$store.dispatch('Tariffing/GET_FREEZED_SERVICE', item.service_id).then(response => {
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/FREEZED_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalFreezedService', '#btnShow')
          })
          break
      }
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Service"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Tariffing/DELETE_SERVICES', item.service_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    timeRangeList () {
      let tmp = []
      for (let el of this.$store.getters['Tariffing/TIME_RANGE']) {
        let newEl = {
          value: el.tr_id,
          text: el.name + ' (' + el.tr_id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    ipPoolsList () {
      let tmp = []
      for (let el of this.$store.getters['Settings/IP_POOLS']) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    schemeList () {
      let tmp = [
        {value: 0, text: '---'}
      ]
      for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    policyList () {
      let tmp = []
      for (let el of this.$store.getters['Tariffing/CHARGE_POLICIES']) {
        let newEl = {
          value: el.policy_id,
          text: el.name + ' (' + el.policy_id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    suppliertList () {
      let tmp = [
        {value: 0, text: ''}
      ]
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/COMPANIES']))
      for (let el of copy) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    groupList () {
      let tmp = [
        {value: 0, text: this.$i18n.t('Don`t delete')}
      ]
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {
          value: el.group_id,
          text: el.group_name + ' (' + el.group_id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    contractList () {
      let tmp = [
        {value: 0, text: ''}
      ]
      for (let el of this.$store.getters['Tariffing/CONTRACT_TYPE']) {
        let newEl = {
          value: el.id,
          text: el.name
        }
        tmp.push(newEl)
      }
      return tmp
    },
    services () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/SERVICES']))
      copy = copy.filter(function (value) {
        return value.parent_id === 0
      })
      for (let el of copy) {
        switch (el.service_type) {
          case 1:
            el.nameServicesType = this.$i18n.t('One-time service')
            break
          case 2:
            el.nameServicesType = this.$i18n.t('Periodic service')
            break
          case 3:
            el.nameServicesType = this.$i18n.t('IP traffic service')
            break
          case 4:
            el.nameServicesType = this.$i18n.t('Hotspot service')
            break
          case 5:
            el.nameServicesType = this.$i18n.t('Dial-up service')
            break
          case 6:
            el.nameServicesType = this.$i18n.t('Telephony service')
            break
          case 8:
            el.nameServicesType = this.$i18n.t('IPTV service')
            break
          case 9:
            el.nameServicesType = this.$i18n.t('Video on demand')
            break
          case 10:
            el.nameServicesType = this.$i18n.t('Freezed service')
            break
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_SERVICES')
    this.$store.dispatch('Users/GET_GROUPS')
    this.$store.dispatch('Tariffing/GET_CONTRACT_TYPE')
    this.$store.dispatch('Settings/GET_COMPANIES')
    this.$store.dispatch('Tariffing/GET_CHARGE_POLICIES')
    this.$store.dispatch('Tariffing/GET_COEFFICIENT_SCHEME')
    this.$store.dispatch('Tariffing/GET_MEDIA_GROUPS')
    this.$store.dispatch('Tariffing/GET_MEDIA_CONTENTS')
    this.$store.dispatch('Settings/GET_IP_POOLS')
    this.$store.dispatch('Settings/GET_IP_POOLS')
    this.$store.dispatch('Tariffing/GET_TIME_RANGE')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/services/main.vue